import { Toaster } from "react-hot-toast";

import React from "react";

const ToasterProvider = () => {
  return <Toaster />;
};

export default ToasterProvider;
